import React from 'react';
import styled from 'styled-components';

const StarContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 2px;
`;

const Star = styled.span`
  color: ${props => props.$filled ? '#ffc107' : '#e0e0e0'};
  font-size: ${props => props.$size || '18px'};
  cursor: ${props => props.$interactive ? 'pointer' : 'default'};
  transition: color 0.2s;

  &:hover {
    color: ${props => props.$interactive ? '#ffc107' : 'inherit'};
  }
`;

const RatingText = styled.span`
  margin-left: 8px;
  font-size: 14px;
  color: #666;
`;

const StarRating = ({ 
  rating = 0, 
  size = '18px',
  showCount = false,
  reviewCount = 0,
  interactive = false,
  onChange = null 
}) => {
  const [hoveredRating, setHoveredRating] = React.useState(0);

  const handleClick = (value) => {
    if (interactive && onChange) {
      onChange(value);
    }
  };

  const handleMouseEnter = (value) => {
    if (interactive) {
      setHoveredRating(value);
    }
  };

  const handleMouseLeave = () => {
    if (interactive) {
      setHoveredRating(0);
    }
  };

  const displayRating = hoveredRating || rating;

  return (
    <StarContainer>
      {[1, 2, 3, 4, 5].map((value) => (
        <Star
          key={value}
          $filled={value <= displayRating}
          $size={size}
          $interactive={interactive}
          onClick={() => handleClick(value)}
          onMouseEnter={() => handleMouseEnter(value)}
          onMouseLeave={handleMouseLeave}
        >
          ★
        </Star>
      ))}
      {showCount && reviewCount > 0 && (
        <RatingText>
          ({rating.toFixed(1)} - {reviewCount} {reviewCount === 1 ? 'reseña' : 'reseñas'})
        </RatingText>
      )}
    </StarContainer>
  );
};

export default StarRating;
